const languageStrings = [
	{
		languageCode: "sv",
		component: {
			common: {
				sek: "SEK",
				years: "år",
				hours: "timmar",
				minutes: "minuter",
				totalPrice: "Totalt pris",
				close: "Stäng",
				abort: "Avbryt",
				numberOf: "Antal",
				from: "från",
				to: "till",
				cancelled: "Avbokad",
				error: "Fel",
				notPaid: "Ej betald",
				person: "person",
				persons: "personer",
				temporary: "Temporär"
			},
			countrySelector: {
				placeholder: "Välj land..."
			},
			cancelBooking: {
				heading: "Avboka",
				infoText: "Avbokning ska ske senast 24 timmar före avresa. Har du köpt en resa med Egen Kupé måste avbokning ske senast sju dygn före avresa. För gruppresor gäller särskilda regler.",
				refundAmount: "Belopp att få tillbaka",
				voucherAmount: "Varav som värdebevis",
				refundInfo: "Vid avbokning av ombokningsbar biljett får du ett värdebevis skickat till din mail. Endast återbetalningsbara biljetter återbetalas.",
				directionLabel: "Vad vill du avboka?",
				directionOutbound: "Enbart utresan",
				directionInbound: "Enbart hemresan",
				directionBoth: "Hela resan",
				cancelButtonText: "Avbryt",
				submitButtonText: "Avboka",
				cancelFailed: "Fel! Det gick inte att avboka bokningen. Kontakta kundtjänst för att avboka den här bokningen."
			},
			completePayment: {
				heading: "Betala bokning",
				infoText: "Denna bokning är inte fullständigt betald. Välj betalsätt för att slutföra betalningen av bokningen.",
				paymentCompleteHeading: "Bokningen är betald",
				paymentCompleteText: "Vi har tagit emot din betalning, vänta eller tryck på OK så skickas du vidare till kvittosidan."
			},
			searchForm: {
				travelFrom: "Resa från",
				travelTo: "Resa till",
				travelFromPlaceholder: "Varifrån vill du resa?",
				travelToPlaceholder: "Vart vill du resa?",
				locationFromPlaceholder: "Börja skriva för att söka station",
				locationToPlaceholder: "Börja skriva för att söka station",
				departureDate: "Utresa",
				departureTime: "Tid på dagen",
				returnDate: "Hemresa",
				single: "Enkel resa",
				return: "Tur & retur",
				requireTwoWay: "<strong>OBS!</strong> För detta avresedatum måste du även boka hemresa.",
				searchButtonText: "Sök resa",
				passengers: "Resenärer",
				addPassenger: "Lägg till fler resenärer",
				removePassenger: "Ta bort resenär",
				selectAge: "Ange ålder",
				travelWithAnimals: "Jag vill resa med djur",
				interrailInfo: "Reser du med interrail måste du i nuläget boka via Kundtjänst.",
				travelWithInterrailCard: "Jag har Interrail-kort",
				interrailReturnWarning: "Du kan bara välja att boka med Interrail-kort för enkelresor",
				interrailModal: {
					title: "Validera Interrail-kort",
					description: "För att kunna boka en resa där du ska resa på Interrail-kort måste du först validera ditt kort.",
					numberLabel: "Ange numret på ditt Mobile Pass eller numret på omslaget på papperskortet.",
					numberPlaceholder: "Kortnummer",
					numberDescription: "Varje resenär måste ha ett unikt nummer.",
					numberInvalid: "Angivet kortnummer är inte giltigt, kontrollera att du skrivit rätt nummer och att ditt kort fortfarande är giltigt.",
					numbersInvalid: "Ett eller flera av dina kortnummer är inte giltiga. Kontrollera att du skrivit rätt nummer. Du kan inte använda samma kortnummer för flera resenärer.",
					validationFailed: "Ett fel uppstod när ditt kortnummer skulle valideras, försök igen senare.",
					buttonText: "Validera"
				}
			},
			dateSelector: {
				lowestPrice: "Lägsta pris",
				hasTraffic: "Snälltåget trafikerar",
				monthWithoutTraffic: "Snälltåget trafikerar ej denna månad",
				selectDate: "Välj datum"
			},
			selectJourney: {
				outboundJourney: "Utresa",
				returnJourney: "Hemresa",
				singleJourney: "Din resa",
				loadingTimetableError: "Fel! Det gick inte att hämta tidtabell!",
				noPrioritizedJourneys: "Tyvärr inga resor med Snälltåget denna dag.",
				timetableSubmit: "Fortsätt",
				timetableBack: "Tillbaka",
				journeyAdvice: {
					direct: "Inga byten",
					change: "Byte",
					changes: "Byten",
					duration: "Restid",
					noPriceText: "Resan är slutsåld",
					priceGroupHeading: "Prisnivå",
					priceGroupLabel: "Välj prisnivå",
					flexibilityLabel: "Biljetten kan",
					flexibilityFIX: "Inte ombokas eller återbetalas",
					flexibilityFLEX: "Ombokas",
					flexibilityFULL: "Återbetalas",
					preferredFlexWarning: "Annat val än på utresan",
					detailsSubmit: "Fortsätt",
				},
				salesRestrictions: {
					"SALES OPENING SOON": "Bokningen öppnar inom kort.",
					"TRAFFIC DISTURBANCE": "Avgången är påverkad av en trafikstörning och kan inte bokas.",
					"TRACKWORKS": "Avgången påverkad av ett ett banarbete, försäljningen tillfälligt stoppad."
				},
				creatingOrder: "Bokar din resa, var vänlig vänta...",
				errorCreatingOrder: "Kunde inte skapa bokning.",
				errorCreatingOrderDetails: "Ett fel uppstod när bokningen skulle skapas."
			},
			orderDetails: {
				travellersHeading: "Resenärer",
				paymentTypeHeading: "Betalsätt",
				orderSummaryHeading: "Sammanställning",
				termsLabel: "Jag har läst och accepterar Snälltågets biljettregler och allmänna villkor",
				termsLinkText: "Läs Snälltågets regler och allmänna villkor",
				termsReminder: "Du måste acceptera villkoren för att kunna fortsätta.",
				submitButtonText: "Bekräfta",
				backButtonText: "Tillbaka",
				finalizingOrder: "Slutför bokning, vänta...",
				finalizingOrderFailed: "Ett fel uppstod då vi försökte slutföra din bokning.",
				passengerDetails: {
					traveller: "Resenär",
					firstnameLabel: "Förnamn",
					lastnameLabel: "Efternamn",
					phoneLabel: "Mobiltelefon",
					phoneHint: "",
					emailLabel: "E-post",
					emailSuggestion: "Menade du",
					birthdateLabel: "Födelsedatum",
					birthdatePlaceholder: "ÅÅÅÅ-MM-DD",
					birthdateError: "Ogiltigt födelsedatum",
					countryLabel: "Boendeland",
					countryHint: "Det land där ditt pass är utfärdat",
					vasaIdInfo: "Ange ditt Vasa ID för att få nummerlappen direkt på tåget. Du hittar ditt Vasa ID under \"Mina sidor\" på vasaloppet.se."
				},
				vouchers: {
					showButtonText: "Betala med värdebevis",
					sectionHeading: "Värdebevis",
					addVoucherLabel: "Värdebeviskod",
					addVoucherButton: "Lägg till",
					remainingAmountInfo: "<strong>Värdebeviset är registrerat!</strong><br />Finns det värde kvar på ditt värdebevis kan du använda det flera gånger inom dess giltighetsperiod."
				},
				discountCode: {
					showSectionButton: "Lägg till rabattkod",
					sectionHeading: "Rabattkod",
					addDiscountCodeLabel: "Eventuell rabattkod",
					addDiscountCodeButton: "Lös in kod",
					errorInfo: "Är det ett värdebevis du ska använda ska du ange detta under betalsätt."
				}
			},
			orderSummary: {
				intro: "Kontrollera att dina reseuppgifter är korrekta",
				carriage: "vagn",
				seat: "plats",
				compartment: "kupé",
				departure: "Avgång",
				arrival: "Ankomst",
				duration: "Restid",
				direct: "Inga byten",
				change: "byte",
				changes: "byten",
				noSeatReservation: "Sträckan saknar möjlighet till platsbokning",
				changeSeats: "Ändra platser",
				options: "Tillval",
				tableBookingsHeading: "Reservera plats i Krogen",
				petWarningPC: "Du har blivit placerad i kupé där husdjur är tillåtna.",
				petWarningPS: "Du har blivit placerad i avdelning där husdjur är tillåtna."
			},
			payment: {
				cancel: "Avbryt",
				paymentComplete: "Betalningen är genomförd, vänta så skickas du till kvittosidan..."
			},
			orderTimeout: {
				timeLeftPrompt: "Tid kvar att slutföra bokningen",
				expired: "Tiden för att slutföra bokningen har gått ut. Vänligen försök igen."
			},
			tableBooking: {
				modalTitle: "Reservera plats i Krogen",
				modalInfoText: "Ni kan komma att dela bord med andra gäster.",
				submitText: "Boka",
				personsLabel: "Antal personer",
				menuOptions: "Menyalternativ",
				menuError: "Ett menyval per gäst måste göras.",
				errorFetchingTables: "Det gick inte att hämta tider",
				errorBookingTable: "Bordsbokning misslyckades",
				fetchingTables: "Hämtar tillgängliga tider...",
				fetchTables: "Hämta tillgängliga tider",
				availableTables: "Tillgängliga tider",
				numberOfGuests: "Antal gäster",
				bookingRequired: "Bordsbokning krävs",
				availableTimes: "Välj önskad tid",
				selectDay: "Välj dag",
				noAvailableTimes: "Det finns inga tillgängliga bord.",
				sharedTable: "När du bokar bord för 1-2 personer kommer du att dela bord med andra gäster.",
				foodInfo: "Från 11 och framåt är borden förbehållna gäster som vill äta varma och kalla rätter från vår meny och alkoholdrycker.",
				bookingTable: "Bokar ditt bord, vänta...",
				bookTableSuccess: "Ditt bord är bokat, bekräftelse kommer via e-post inom ca 15 minuter. Har du köpt resan genom SJ eller Vy kommer ingen e-postbekräftelse.",
				tableBooked: "Bord bokat",
				changeTime: "Ändra",
				cancel: "Avboka bord",
				cancelConfirm: "Är du säker på att du vill avboka ditt bord i Krogen kl",
				slots: {
					frukost: "Frukost",
					frukost1: "Frukost",
					frukost2: "Frukost",
					lunch: "Lunch",
					lunch1: "Lunch",
					lunch2: "Lunch",
					middag: "Middag",
					middag1: "Middag",
					middag2: "Middag"
				},
				mealBookingDialog: {
					bookedMealsTitle: "Bokade måltider",
					bookedTablesTitle: "Bordsbokningar",
					mealBookingInfo: "Måltider i Krogen på denna sträcka måste förbokas.",
					editDisabled: "Kontakta kundtjänst om du vill göra ändringar i dina bords- eller måltidsbokning.",
					openDialogButton: "Boka måltider",
					title: "Förboka mat och reservera plats i Krogen",
					confirmCancel: "Är du säker på att du vill avbryta? Dina preliminära bordsbokningar kommer avbokas.",
					optionsLoading: "Hämtar måltidsalternativ...",
					noOptions: "Bordsbokningen är för närvarande stängd.",
					submitButton: "Vidare",
					wrongNumberOfPeopleWarning: "Fel antal personer!",
					bookingTablePrel: "Preliminärbokar bord...",
					bookingTable: "Bokar bord...",
					tableBookedPrel: "Bord preliminärbokat",
					tableBooked: "Bord bokat"

				}
			},
			compensationForm: {
				modalTitle: "Ersättning vid försening enligt EG 1371/2007",
				infoText: "Om Snälltåget är mer än 60 minuter försenat kan du ansöka om ersättning enligt EG 1371/2007 artikel 17 genom att fylla i formuläret nedan. Är tåget 60-119 minuter försenat vid ankomst har du rätt till 25 % ersättning av biljettpriset och är tåget mer än 120 minuter försenat har du rätt till 50 % av biljettpriset i ersättning. Snälltåget ersätter inte andra utlägg och merkostnader du kan ha haft i samband med försening, t ex taxi, utebliven arbetsinkomst etc. Handläggningstiden är normalt ca 3-4 veckor.",
				submitText: "Skicka in begäran",
				closeText: "Stäng",
				reservationNo: "Bokningsnummer",
				firstName: "Förnamn",
				lastName: "Efternamn",
				email: "E-postadress",
				phone: "Telefonnummer (frivilligt)",
				selectTrip: "Vilken resa begär du ersättning för?",
				allTrips: "Alla sträckor ovan",
				selectPaymentmethod: "Hur önskar du din ersättning?",
				optionVoucher: "Värdebevis för resa med Snälltåget (du får 50 kr extra)",
				optionAccount: "Kontant utbetalning till bankkonto",
				accountSwedish: "Svenskt konto",
				accountIntl: "Utländskt konto",
				account: "Clearing och kontonummer",
				clearingNo: "Clearingnr",
				accountNo: "Kontonr",
				required: "måste anges",
				notvalid: "är inte giltigt",
				personid: "Personnummer",
				address: "Postadress",
				zip: "Postnummer",
				city: "Postort",
				country: "Land",
				thankYouText: "Tack. Handläggningstiden för ersättningsärenden är normalt ca 3-4 veckor.",
				submitError: "Ett fel har tyvärr uppstått. Vi ber dig prova igen senare."
			},
			options: {
				optionGroups: {
					krogen: "Krogen",
					takeAway: "Takeaway från Krogen",
					bagage: "Bagage",
					others: "Övriga"
				},
				editOptions: {
					modalTitle: "Ändra tillval",
					headingOutbound: "Tillval för utresa",
					headingReturn: "Tillval för hemresa",
					loadingOptions: "Hämtar tillgänliga tillval...",
					noOptionsAvailable: "Det finns inga tillgänliga tillval på denna resa.",
					submitChangesNoFee: "Genomför ändring",
					submitError: "<strong>Fel!</strong> Det gick inte att genomföra ändringen. Vänligen försök igen senare, eller kontakta kundtjänst för att ändra dina tillval.",
					optionSumText: "Summa nya tillval",
					optionsUpdatedHeading: "Tillvalen uppdaterade",
					optionsUpdatedText: "Dina ändringar är mottagna, och tillvalen på din bokning är uppdaterade.",
					optionsPaymentText: "För att slutföra ändringen av tillvalen måste du betala den utestående summan {totalPriceToBePaid} kr."
				}
			},
			booking: {
				findBookingHeader: "Sök bokning",
				emailOrPhone: "E-postadress eller telefonnummer",
				search: "Sök",
				bookingNumberInvalid: "Bokningsnummer måste fyllas i, 6 tecken.",
				bookingNumberTooLong: "Har du bokat din resa via SJ eller annan återförsäljare ska du använda de första 6 tecknen i biljettnumret som du hittar under bokningsnumret på din biljett.",
				loading: "Hämtar bokning...",
				bookingNotFound: "Hittar inte bokningen",
				unableToLoad: "Det gick inte att hämta bokningen",
				bookingHeader: "Din bokning",
				created: "Bokning skapad",
				bookingNumber: "Bokningsnummer",
				outbound: "Utresa",
				inbound: "Hemresa",
				totalPrice: "Totalt pris",
				amountPaid: "Betalt belopp",
				passengers: "Resenärer",
				completePayment: "Slutför betalning",
				completePaymentVouchersOnly: "Slutför betalning med värdebevis",
				paymentError: "Ett fel uppstod när betalningen skulle påbörjas",
				cancelButton: "Avboka din resa",
				cancelled: "Denna bokning har blivit avbokad.",
				noRebookInfo: "Den här bokningen går inte att avboka eller boka om på webben. Kontakta Snälltågets kundtjänst på epost <a href=\"mailto:snalltaget@snalltaget.se\">snalltaget@snalltaget.se</a>. Har du köpt resan genom SJ eller Vy ska du avboka resan genom där.",
				functionOptions: "Hantera tillval",
				functionCompensation: "Försenad?",
				resendTicketsButton: "Skicka biljetter igen",
				resendTicketsSuccess: "Biljetterna har skickats till epostadressen i bokningen.",
				resendTicketsFailed: "Det gick inte att skicka biljetterna igen.",
				klarnaInfoHeading: "Betalning med Klarna",
				klarnaInfo: "Ibland kan det ta lång tid för betalningen att bekräftas vid betalning med Klarna. Detta är ingenting Snälltåget kan påverka. Bokningsbekräftelsen skickas till din epost så fort betalningsbekräftelsen kommit. Vänta alltid <em>minst 20 minuter</em> på bekräftelsen innan du försöker göra en ny bokning."
			},
			s3Errors: {
				3165: "Beklagar, men den önskade prisnivån är slutsåld!",
				3034: "Beklagar, men den önskade prisnivån är slutsåld!"
			}
		}
	},
	{
		languageCode: "en",
		component: {
			common: {
				sek: "SEK",
				years: "years",
				hours: "hours",
				minutes: "minutes",
				totalPrice: "Total price",
				close: "Close",
				abort: "Cancel",
				numberOf: "Number of",
				from: "from",
				to: "to",
				cancelled: "Cancelled",
				error: "Error",
				notPaid: "Not paid",
				person: "person",
				persons: "persons",
				temporary: "Temporär"
			},
			countrySelector: {
				placeholder: "Select country..."
			},
			cancelBooking: {
				heading: "Cancel booking",
				infoText: "The booking must på cancelled at the latest 24 hours before departure. If you have purchased a ticket with your own compartment, it must be cancelled at least 7 days before departures. Special rules applies to group bookings.",
				refundAmount: "Amount to be refunded",
				voucherAmount: "As a voucher",
				refundInfo: "For rebookable tickets, no money is refunded. Only refundable tickets can be refunded.",
				directionLabel: "What do you want to cancel?",
				directionOutbound: "Outbound only",
				directionInbound: "Return only",
				directionBoth: "Entire booking",
				cancelButtonText: "Abort",
				submitButtonText: "Cancel booking",
				cancelFailed: "An error occurred while cancelling the booking. Please contact customer service to cancel the booking."
			},
			completePayment: {
				heading: "Pay booking",
				infoText: "This booking is not fully paid. Please choose a payment type in order to complete the payment.",
				paymentCompleteHeading: "Payment complete",
				paymentCompleteText: "We have received your payment, please wait or click OK to be redirected to the receipt."
			},
			dateSelector: {
				lowestPrice: "Best price",
				hasTraffic: "Snälltåget has traffic",
				monthWithoutTraffic: "No traffic with Snälltåget this month",
				selectDate: "Select date"
			},
			searchForm: {
				travelFrom: "Travel from",
				travelTo: "Travel to",
				travelFromPlaceholder: "Travelling from?",
				travelToPlaceholder: "Travelling to?",
				locationFromPlaceholder: "Start typing to find location",
				locationToPlaceholder: "Start typing to find location",
				departureDate: "Departure",
				departureTime: "Time of day",
				returnDate: "Return",
				single: "One way",
				return: "Return trip",
				requireTwoWay: "<strong>NB</strong> For this departure date, you are required to also book a return trip.",
				searchButtonText: "Search",
				passengers: "Travellers",
				addPassenger: "Add traveller",
				removePassenger: "Remove traveller",
				selectAge: "Select age",
				travelWithAnimals: "I want to travel with a pet",
				interrailInfo: "If you're travelling with an Interrail or Eurail pass - please contact customer service for booking.",
				travelWithInterrailCard: "I have an Interrail or Eurail Pass",
				interrailReturnWarning: "You can only select Interrail or Eurail Pass for one way journeys",
				interrailModal: {
					title: "Validate Interrail or Eurail Pass",
					description: "In order to make a reservation, you must first validate your Pass.",
					numberLabel: "Enter your mobile pass number for a Mobile Pass or the pass cover number for a Paper Pass.",
					numberPlaceholder: "Pass number",
					numberDescription: "Each Passenger need a specific Pass number.",
					numberInvalid: "Invalid Pass number. Please check that you have entered the correct number and that your pass is still valid.",
					numbersInvalid: "One or more of your Pass numbers are invalid. Please check that you have entered them correctly. You can not use the same number for more than one traveller.",
					validationFailed: "An error occured when validating your Pass number(s), please try again later.",
					buttonText: "Validate"
				}
			},
			selectJourney: {
				outboundJourney: "Outbound journey",
				returnJourney: "Return journey",
				singleJourney: "Your journey",
				loadingTimetableError: "Error! Could not load timetable!",
				noPrioritizedJourneys: "Unfortunately no departures with Snälltåget on this day.",
				timetableSubmit: "Continue",
				timetableBack: "Back",
				journeyAdvice: {
					direct: "No changes",
					change: "Change",
					changes: "Changes",
					fewSeats: "Few seats left",
					duration: "Travel time",
					noPriceText: "The departure is sold out",
					priceGroupHeading: "Price level",
					priceGroupLabel: "Select price level",
					flexibilityLabel: "The ticket is",
					flexibilityFIX: "Not rebookable or refundable",
					flexibilityFLEX: "Rebookable",
					flexibilityFULL: "Refundable",
					preferredFlexWarning: "Different than on outbound journey",
					detailsSubmit: "Continue"
				},
				salesRestrictions: {
					"SALES OPENING SOON": "Sales opening soon.",
					"TRAFFIC DISTURBANCE": "Departure affected by a traffic disturbance and not possible to book.",
					"TRACKWORKS": "Departure affected by track maintenace work, sales temporary closed."
				},
				creatingOrder: "Creating reservation, please wait...",
				errorCreatingOrder: "Could not create reservation",
				errorCreatingOrderDetails: "An error occured when booking your journey"
			},
			orderDetails: {
				travellersHeading: "Travellers",
				paymentTypeHeading: "Payment Type",
				orderSummaryHeading: "Order Summary",
				termsLabel: "I have read and accept Snälltåget's ticket rules and general terms",
				termsLinkText: "Read Snälltåget's rules and general terms",
				termsReminder: "You have to accept the terms in order to continue.",
				submitButtonText: "Confirm",
				backButtonText: "Back",
				finalizingOrder: "Finalizing order, please wait...",
				finalizingOrderFailed: "An error occured while finalizing your order.",
				passengerDetails: {
					traveller: "Traveller",
					firstnameLabel: "First name",
					lastnameLabel: "Last name",
					phoneLabel: "Mobile phone",
					phoneHint: "Please enter phone number in international format.",
					emailLabel: "Email",
					emailSuggestion: "Did you mean",
					birthdateLabel: "Birth date",
					birthdateError: "Invalid birth date, please use the form YYYY-MM-DD",
					countryLabel: "Country of residence",
					countryHint: "Country of your Passport",
					vasaIdInfo: "Enter you Vasa ID in order to get your start number and chip directly on the train. You can find your Vasa ID under \"My pages\" on vasaloppet.se."
				},
				vouchers: {
					showButtonText: "Pay with vouchers",
					sectionHeading: "Vouchers",
					addVoucherLabel: "Voucher code",
					addVoucherButton: "Add",
					remainingAmountInfo: "<strong>Your voucher is registered!</strong><br />If there is a remaining value on your voucher, you can use it several times within its validity period."
				},
				discountCode: {
					showSectionButton: "Add discount code",
					sectionHeading: "Discount code",
					addDiscountCodeLabel: "Enter code (if you have one)",
					addDiscountCodeButton: "Submit code",
					errorInfo: "If you are trying to pay with a voucher, you should select pay with vouchers below."
				}
			},
			orderSummary: {
				intro: "Please verify that the order is correct",
				carriage: "carriage",
				seat: "seat",
				compartment: "compartment",
				departure: "Departure",
				arrival: "Arrival",
				duration: "Travel time",
				direct: "No changes",
				change: "change",
				changes: "changes",
				noSeatReservation: "Seat reservation not possible on this segment",
				changeSeats: "Change seats",
				options: "Additional options",
				tableBookingsHeading: "Reserve seats in Krogen",
				petWarningPC: "You have been seated in a pet compartment.",
				petWarningPS: "You have been seated in a pet zone."
			},
			payment: {
				cancel: "Cancel",
				paymentComplete: "Payment complete, please wait while you are being redirected..."
			},
			orderTimeout: {
				timeLeftPrompt: "Time left to complete the booking",
				expired: "The time to finish your reservation has expired. Please try again."
			},
			tableBooking: {
				modalTitle: "Reserve seats in Krogen",
				modalInfoText: "You may have to share table with other guests",
				submitText: "Book seats",
				personsLabel: "Number of persons",
				menuOptions: "Menu options",
				menuError: "You need to select one menu option for every guest.",
				bookingRequired: "Table booking required",
				errorFetchingTables: "Could not fetch available times.",
				errorBookingTable: "Table booking failed.",
				fetchingTables: "Fetching available times...",
				numberOfGuests: "Number of guests",
				availableTimes: "Available times",
				selectDay: "Select day",
				fetchTables: "Find available times",
				availableTables: "Available times",
				noAvailableTimes: "There are no tables available.",
				sharedTable: "When you book a table for 1-2 persons, you will have to share a table with other guests.",
				foodInfo: "From 11 AM onwards, the tables are reserved for guests who wish to eat hot and cold dishes from our menu and alcoholic drinks.",
				bookTableSuccess: "Your table has been booked, we will send an email confirmation within about 15 minutes. If you have purchased your ticket through SJ or Vy, no confirmation will be sent.",
				tableBooked: "Table booked at",
				changeTime: "Change",
				cancel: "Cancel table",
				cancelConfirm: "Are you sure you want to cancel your table reservation at",
				slots: {
					frukost: "Breakfast",
					frukost1: "Breakfast",
					frukost2: "Breakfast",
					lunch: "Lunch",
					lunch1: "Lunch",
					lunch2: "Lunch",
					middag: "Dinner",
					middag1: "Dinner",
					middag2: "Dinner"
				},
				mealBookingDialog: {
					bookedMealsTitle: "Booked meals",
					bookedTablesTitle: "Table bookings",
					mealBookingInfo: "Meals in Krogen on this segment must be pre-booked..",
					editDisabled: "In order to make changes in your meal or table bookings, please contact Customer Service.",
					openDialogButton: "Book meals",
					title: "Pre-order meals and reserve seats in Krogen",
					confirmCancel: "Are you sure you want to cancel? Your preliminary table bookings will be cancelled..",
					optionsLoading: "Loading meal options...",
					noOptions: "The table booking is currently closed.",
					submitButton: "Continue",
					wrongNumberOfPeopleWarning: "Wrong number of persons!",
					bookingTablePrel: "Creating preliminary table reservation...",
					bookingTable: "Reserving table...",
					tableBookedPrel: "Table preliminary booked at",
					tableBooked: "Table booked at"

				}
			},
			compensationForm: {
				modalTitle: "Compensation according to EG 1371/2007",
				infoText: "",
				submitText: "Submit",
				closeText: "Close",
				reservationNo: "Reservation no",
				firstName: "First name",
				lastName: "Last name",
				email: "Email address",
				phone: "Phone (optional)",
				selectTrip: "Select trip for compensation",
				allTrips: "All trips above",
				selectPaymentmethod: "Select how you would like the caompensation",
				optionVoucher: "Snälltåget Voucher",
				optionAccount: "Bank account",
				accountSwedish: "Swedish account",
				accountIntl: "International account",
				account: "Clearing and account number",
				clearingNo: "Clearing no",
				accountNo: "Account no",
				required: "required",
				notvalid: "not valid",
				personid: "",
				address: "Postal address",
				zip: "Zip/Post code",
				city: "City",
				country: "Country",
				thankYouText: "Thank you. The processing time for compensations is usually 3-4 weeks.",
				submitError: "An error has occured. Please try again later."
			},
			options: {
				optionGroups: {
					krogen: "Krogen (restaurant coach)",
					takeAway: "Takeaway from Krogen",
					bagage: "Luggage",
					other: "Others"
				},
				editOptions: {
					modalTitle: "Edit options",
					headingOutbound: "Select options for outbound journey",
					headingReturn: "Select options for return journey",
					loadingOptions: "Loading available options...",
					noOptionsAvailable: "There are no available options on this journey.",
					submitChangesNoFee: "Update options",
					submitError: "<strong>Error!</strong> It was not possible to update your options. Please try again later or contact Customer Service to change your options.",
					optionSumText: "Sum new options",
					optionsUpdatedHeading: "Options updated",
					optionsUpdatedText: "Your changes have been received, and the options on your booking have been updated.",
					optionsPaymentText: "In order to complete the option change, you will need to pay the outstanding amount of SEK {totalPriceToBePaid}."
				}
			},
			booking: {
				findBookingHeader: "Find booking",
				emailOrPhone: "Email address or phone number",
				bookingNumberInvalid: "Booking number (6 characters) is required.",
				bookingNumberTooLong: "If you have booked your your journey through SJ or another reseller, use the first 6 characters of the ticketnumber that you find below the booking number on your ticket.",
				search: "Search",
				loading: "Loading booking...",
				bookingNotFound: "Unable to find booking",
				unableToLoad: "Could not load booking",
				bookingHeader: "Your booking",
				created: "Booking created",
				bookingNumber: "Booking number",
				outbound: "Outbound travel",
				inbound: "Return travel",
				totalPrice: "Total price",
				amountPaid: "Amount paid",
				passengers: "Passengers",
				completePayment: "Complete payment",
				completePaymentVouchersOnly: "Complete payment with voucher(s)",
				paymentError: "An error occured while trying to initiate the payment",
				cancelButton: "Cancel booking",
				cancelled: "This booking has been cancelled.",
				noRebookInfo: "It is not possible to cancel or rebook this booking on the website. Please contact customer service via email <a href=\"mailto:snalltaget@snalltaget.se\">snalltaget@snalltaget.se</a>. If you have purchased you ticket through SJ or Vy, you should cancel your booking there.",
				functionOptions: "Manage options",
				functionCompensation: "Delayed?",
				resendTicketsButton: "Resend tickets",
				resendTicketsSuccess: "The tickets have been sent to the email address in the booking.",
				resendTicketsFailed: "An error occurred, unable to resend tickets.",
				klarnaInfoHeading: "Payment with Klarna",
				klarnaInfo: "When paying with Klarna, sometimes the payment confirmation takes a long time to arrive. This is something Snälltåget has no control over. The booking confirmation will be sent to your email address as soon as we receive the payment confirmation. Always wait <em>at least 20 minutes</em> before making another booking."
			},
			s3Errors: {
				3165: "Sorry, but the desired price level is sold out!",
				3034: "Sorry, but the desired price level is sold out!"
			}
		}
	}
];

export const currentLanguage = () => {
	let lang = "sv";
	if (document?.documentElement?.lang)
		lang = document.documentElement.lang.substring(0,2);
	return lang;
};

export const getStrings = function() {
	const lang = currentLanguage();

	return languageStrings.filter(x => x.languageCode === lang)[0];
};